import { ActionType } from "typesafe-actions";
import * as notificationsActions from "./actions";
import { TourActionTypes, TourState } from "./types";
import { Reducer } from "redux";
import {
  getBooleanFromLocalStorage,
  LocalStorageKeys,
} from "../../utils/LocalStorageUtils";

export type TourAction = ActionType<typeof notificationsActions>;

const initialState: TourState = {
  firstUploadTourShown: getBooleanFromLocalStorage(
    LocalStorageKeys.FirstUploadTour
  ),
  sidebarPositionTourShown: getBooleanFromLocalStorage(
    LocalStorageKeys.SidebarPositionTour
  ),
  prepareMeetingTourShown: getBooleanFromLocalStorage(
    LocalStorageKeys.PrepareMeetingTour
  ),
  implementMeetingTourShown: getBooleanFromLocalStorage(
    LocalStorageKeys.ImplementMeetingTour
  ),
  interventionFidelityTourShown: getBooleanFromLocalStorage(
    LocalStorageKeys.InterventionFidelityTour
  ),
  fidelityChartTourShown: getBooleanFromLocalStorage(
    LocalStorageKeys.FidelityChartTour
  ),
  emptyDataPeriodViewTourShown: getBooleanFromLocalStorage(
    LocalStorageKeys.EmptyDataPeriodViewTour
  ),
  addSecondaryGoalPositionTourShown: false,
};

// NOTE: persisting each "*TourShown" flag to localStorage is handled by
// `persistenceMiddleware`, so these reducer branches stay pure and only
// update in-memory state.
const reducer: Reducer<TourState> = (
  state: TourState = initialState,
  action: TourAction
): TourState => {
  switch (action.type) {
    case TourActionTypes.MARK_FIRST_UPLOAD_TOUR_AS_SHOWN: {
      return {
        ...state,
        firstUploadTourShown: true,
      };
    }
    case TourActionTypes.MARK_SIDEBAR_POSITION_TOUR_AS_SHOWN: {
      return {
        ...state,
        sidebarPositionTourShown: true,
      };
    }
    case TourActionTypes.MARK_PREPARE_MEETING_TOUR_AS_SHOWN: {
      return {
        ...state,
        prepareMeetingTourShown: true,
      };
    }
    case TourActionTypes.MARK_IMPLEMENT_MEETING_TOUR_AS_SHOWN: {
      return {
        ...state,
        implementMeetingTourShown: true,
      };
    }
    case TourActionTypes.MARK_INTERVENTION_FIDELITY_TOUR_AS_SHOWN: {
      return {
        ...state,
        interventionFidelityTourShown: true,
      };
    }
    case TourActionTypes.MARK_FIDELITY_CHART_TOUR_AS_SHOWN: {
      return {
        ...state,
        fidelityChartTourShown: true,
      };
    }
    case TourActionTypes.MARK_EMPTY_DATA_PERIOD_VIEW_TOUR_AS_SHOWN: {
      return {
        ...state,
        emptyDataPeriodViewTourShown: true,
      };
    }
    case TourActionTypes.CHANGE_SELECTED_INTERVENTION_GROUP_ID: {
      return {
        ...state,
        selectedInterventionGroupId: action.payload,
      };
    }
    case TourActionTypes.MARK_ADD_SECONDARY_GOAL_TOUR_AS_SHOWN: {
      
      return {
        ...state,
        addSecondaryGoalPositionTourShown: action.payload,
      };
    }
    default:
      return state;
  }
};

export { reducer as tourReducer };
